

import React, { useRef } from 'react'
import useUsers from '../../store/users/usersContext';
import { useTable, useGlobalFilter, usePagination, useFilters, useSortBy } from 'react-table'
import SelectColumnFilter from '../ReactTable/SelectColumnFilter';
import { useHistory } from 'react-router';
import { USER_TYPES, COLORS } from '../../config';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import SecondaryButtonAccent from '../../components/Buttons/SecondaryButtonAccent';
import PlusIcon from '../../components/Icons/solid/PlusIcon';
import AdjustmentsIcon from '../../components/Icons/solid/AdjustmentsIcon';
import DotsIcon from '../../components/Icons/solid/DotsIcon';
import useApp from '../../store/app/appContext';
import GlobalFilter from '../ReactTable/GlobalFilter';
import TablePagination from '../ReactTable/TablePagination';
import FiltersModal from '../ReactTable/FiltersModal';
import SortAscSmall from '../../components/Icons/solid/SortAscSmall';
import SortDescSmall from '../../components/Icons/solid/SortDescSmall';
import MoonLoader from 'react-spinners/MoonLoader'
import ProfilePicture from '../../components/App/ProfilePicture';
import TableRowSubMenu from '../../components/Menus/TableRowSubMenu';
import UserIcon from '../../components/Icons/outline/UserIcon';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import ScanIcon from '../../components/Icons/outline/ScanIcon';

function PatientsList() {

  const ref =  useRef();
  
  const { usersState : { allUsers }, getAllUsers } = useUsers();
  const { appState : { user : loggedUser, userAccount } } = useApp();

  const history = useHistory();

  const [isLoading, setIsLoading] = React.useState(true);
  const [showSubMenu, setShowSubMenu] = React.useState({
    active: false,
    row: null
  })

  useOnClickOutside(
    ref,
    setShowSubMenu.bind(this, {
      active: false,
      row: null,
    })
  );

  React.useEffect(() => {
    getAllUsers().then(() => setIsLoading(false));
  }, [])

  const [showFilters, setShowFilters] = React.useState(false)

  const data = React.useMemo(
    () => []
  
  , [allUsers]);
  
  const patients = allUsers.filter(user => user.user_type === USER_TYPES.PATIENT)

  if (allUsers.length && !data.length) {
    patients.map(user => (
      data.push({
        profile_pic_url: user.profile_pic_url,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        mobile: user.mobile_nb,
        country: user.location.country,
        city: user.location.city,
        id: user._id,
        active: user.active ? 'Yes' : 'No'
      })
    ))
  }

  const handleRowSubMenuClick = (row) => {
    setShowSubMenu({
      active: !showSubMenu.active,
      row: row
    })
  }

  const handleViewDetails = (rowIndex) => {
    history.push('/manage-patients/' + patients[rowIndex]._id)
    setShowSubMenu({
      active: false,
      row: null
    })
  }

  const handleViewScans = (rowIndex) => {
    history.push('/manage-patients/scans/' + patients[rowIndex]._id)
    setShowSubMenu({
      active: false,
      row: null
    })
  }

  const defaultColumn = React.useMemo(() => {
    return {
      Filter: SelectColumnFilter
    }
  }, [])

  
  const columns = React.useMemo(
    () => [
      {
        Header: '',
        accessor: 'profile_pic_url',
        disableFilters: true,
      },
      {
        Header: 'First Name',
        accessor: 'first_name',
        disableFilters: true,
      },
      {
        Header: 'Last Name',
        accessor: 'last_name',
        disableFilters: true,
      },
      {
        Header: 'Email',
        accessor: 'email',
        disableFilters: true,
      },
      {
        Header: 'Country',
        accessor: 'country',
      },
      {
        Header: 'City',
        accessor: 'city',
      },
      {
        Header: 'Mobile',
        accessor: 'mobile',
        disableFilters: true,
      },  
    ], []
  );

  if (loggedUser.user_type === USER_TYPES.ROOT) columns.push(
    {
      Header: 'Active',
      accessor: 'active',
    },
  );

  const { 
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    gotoPage,
    prepareRow,
    state : { globalFilter, pageIndex, pageSize },
    preGlobalFilteredRows,
    setGlobalFilter,
    setAllFilters
  } = useTable(
    {
      columns,
      data,
      defaultColumn
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );


  return (
    <div className='w-full rounded bg-white shadow '>
      <FiltersModal
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        headerGroups={headerGroups}
        setAllFilters={setAllFilters}
      />
      <div className='p-2 xl:p-4 grid grid-cols-1 gap-y-2 lg:flex lg:items-center w-full'>
        <SecondaryButtonAccent text="Add Patient" onClick={() => history.push('/manage-patients/add')} icon={<PlusIcon fill={COLORS.colorPrimary}/>}/>
        <SecondaryButton text="Set filters" onClick={() => setShowFilters(true)} className='lg:ml-auto lg:mr-2' icon={<AdjustmentsIcon fill={COLORS.colorSecondary}/>}/>
        <div>
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
          />
        </div>
      </div>
      {isLoading && 
      <div className='flex justify-around min-h-170 pt-8'>
        <MoonLoader color={COLORS.colorPrimary}/>
      </div> 
      }
      {!isLoading &&
      <div className='overflow-x-scroll '>
        <table {...getTableProps()} className='w-full mt-4 border-8 border-transparent '>
          <thead >
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())} className='text-secondary xl:px-2 pb-3 border-b-2 border-gray-100 text-left text-base font-semibold'>
                  <span className='flex items-center'>
                  {column.render('Header')}
                  {column.isSorted ? 
                    column.isSortedDesc ? 
                      <SortAscSmall style={'ml-1 h-5 w-5'}/>
                      : <SortDescSmall style={'ml-1 h-5 w-5'} />
                  : ''}
                  </span>
                </th>
                ))}
                <th className='text-left xl:px-2 pb-3 border-b-2 border-gray-100 '></th>  
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()} className={`border-b-2 border-gray-100`}>
                  {row.cells.map(cell => {
                    if (cell.column.id === 'profile_pic_url') {
                      return (
                        <td {...cell.getCellProps()} className='px-2 pl-8'>
                          <ProfilePicture small user={row.original}/>
                        </td>
                      )
                    };
                    if (cell.column.id === 'first_name') {
                      return (
                        <td {...cell.getCellProps()} className='text-secondary font-medium xl:px-2 py-3'>
                        {cell.render('Cell')}
                        </td>
                      )
                    };
                    if (cell.column.id === 'city') {
                      return (
                        <td {...cell.getCellProps()} className='text-gray-500 font-medium xl:px-2 py-3'>
                        {cell.render('Cell')}
                        </td>
                      )
                    };
                    return (
                      <td {...cell.getCellProps()} className='text-gray-500  xl:px-2 py-3'>
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                  <td className='text-left xl:px-2 relative'>
                    <div ref={ref} className='cursor-pointer flex flex-row-reverse '>
                      <DotsIcon vertical fill={COLORS.colorShade} onClick={() => handleRowSubMenuClick(row.index)}/>
                    </div>
                    {showSubMenu.active && showSubMenu.row === row.index &&
                    <TableRowSubMenu>
                      <ul className='whitespace-nowrap'>
                        <li className='cursor-pointer flex items-center' onClick={() => handleViewDetails(row.index)}>
                          <UserIcon size='w-5 h-5' stroke={COLORS.colorPrimary}/>
                          <span className='ml-3'>View patient details</span>
                        </li>
                        {userAccount.isAdmin && 
                        <li className='cursor-pointer flex items-center' onClick={() => handleViewScans(row.index)}>
                          <ScanIcon size='w-5 h-5' stroke={COLORS.colorPrimary}/>
                          <span className='ml-3'>View patient scans</span>
                        </li>
                        }
                      </ul>
                    </TableRowSubMenu>}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      }
      <TablePagination   
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        previousPage={previousPage}
        nextPage={nextPage}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
        pageSize={pageSize}
        gotoPage={gotoPage}
      />
    </div>
  )
}

export default PatientsList
